//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';

import DestinationsView from './DestinationsView';
import SourcesView from './SourcesView';
import type { Dispatch } from 'state/types';
import { hideDialogPanel } from 'state/commands/dialogPanelCommands';
import { getActivePanelId } from 'state/selectors';
import { DIR_SVC_MAPPINGS_PANEL_ID } from 'util/constants';
import localizedStrings from 'util/localizedStrings';
import { bindActionCreatorsSafe } from 'util/safeDispatch';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import { actions } from 'state/reducers/dirSvcReducer';
const { resetState } = actions;

type Props = {
  activePanelId?: string,
  hideDialogPanel: typeof hideDialogPanel,
  resetState: typeof resetState,
};

class DirectoryServicesMappingsPage extends Component<Props> {
  handleClose: Function;
  constructor() {
    super();
    this.handleClose = this.handleClose.bind(this);
  }
  handleClose() {
    const { hideDialogPanel, resetState } = this.props;
    resetState();
    hideDialogPanel();
  }
  renderHeader() {
    return (
      <div className="dialog-panel-header">
        <div className="dialog-panel-title">
          <FormattedMessage {...localizedStrings.DIRECTORY_SERVICE_MAPIINGS} />
          <button
            className="delete is-large is-pulled-right"
            data-test-name="cancel"
            onClick={this.handleClose}
          />
        </div>
      </div>
    );
  }
  render() {
    const { activePanelId } = this.props;
    return (
      <DialogPanel
        activePanelId={activePanelId}
        contentStyle={{ width: '1180px', height: '90%' }}
        dataTestName="directory-services-configuration-mappings"
        hideDialogPanel={this.props.hideDialogPanel}
        panelHeader={this.renderHeader()}
        panelId={DIR_SVC_MAPPINGS_PANEL_ID}
        showFooter={false}
      >
        <div className="columns is-gapless" style={{ width: '100%' }}>
          <SourcesView />
          <DestinationsView />
        </div>
      </DialogPanel>
    );
  }
}

export default connect(
  state => ({
    activePanelId: getActivePanelId(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsSafe({ hideDialogPanel, resetState })
)(injectIntl(DirectoryServicesMappingsPage));



// WEBPACK FOOTER //
// ./src/view/Pages/DirectoryServicesPage/DirectoryServicesMappingsPage.js